import React from 'react';
import type { RevenueMonth } from '../../types/admin';

/**
 * Seven months of MRR as columns, with new revenue stacked on the retained
 * base so growth and churn read at a glance.
 */
export function MrrChart({
  months
}: {
  months: RevenueMonth[];
}) {
  const peak = Math.max(...months.map(m => m.mrr));
  return <div data-id="element-59" data-mp="1qcnfv9ueisyo">
      <div className="flex h-[172px] items-end gap-3" data-id="element-60" data-mp="1qcdujzkax9zb">
        {months.map(month => {
        const total = month.mrr / peak * 100;
        const fresh = month.newMrr / peak * 100;
        return <div key={month.month} className="group flex min-w-0 flex-1 flex-col items-center justify-end" data-id="element-61" data-mp="207xm69ru1mi9">
              <span className="mb-2 font-mono text-[11px] text-ink-soft opacity-0 transition-opacity duration-150 ease-snap group-hover:opacity-100" data-id="element-62" data-mp="2a039v7b1xhrn">
                ${month.mrr}
              </span>
              <span className="flex w-full max-w-[54px] flex-col justify-end overflow-hidden rounded-t" style={{
            height: `${total}%`
          }} data-id="element-63" data-mp="2izqfk5atd9qi">
                <span className="w-full shrink-0 bg-brand-bright" style={{
              height: `${fresh / total * 100}%`
            }} data-id="element-64" data-mp="30no35wqa83bg" />
                <span className="w-full flex-1 bg-brand" data-id="element-65" data-mp="2vqfjfrphjr83" />
              </span>
            </div>;
      })}
      </div>

      <div className="mt-2 flex gap-3 border-t border-line pt-2" data-id="element-66" data-mp="3od0izfg479mq">
        {months.map(month => <span key={month.month} className="min-w-0 flex-1 text-center font-mono text-[11px] text-ink-soft" data-id="element-67" data-mp="3je5ubwvguqup">
            {month.month}
          </span>)}
      </div>

      <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2" data-id="element-68" data-mp="39om9ilo70mx7">
        <span className="flex items-center gap-1.5 text-xs text-ink-muted" data-id="element-69" data-mp="39m01ym1ay7ez">
          <span className="h-2.5 w-2.5 rounded-sm bg-brand" aria-hidden="true" data-id="element-70" data-mp="azoubcflbmyq" />
          Retained
        </span>
        <span className="flex items-center gap-1.5 text-xs text-ink-muted" data-id="element-71" data-mp="662nw200sfbd">
          <span className="h-2.5 w-2.5 rounded-sm bg-brand-bright" aria-hidden="true" data-id="element-72" data-mp="20giz14broms9" />
          New this month
        </span>
      </div>
    </div>;
}